let debugModeValue = false;

export const initDebugMode = () => {
  debugModeValue =
    new URLSearchParams(window.location.search).get('debug') === 'true';
};

export const isDebugMode = () => debugModeValue;
